export const MODAL_NAME = 'orders.refund-orderline'
export const FORM_ID = 'orders.refund-orderline'

export const INITIAL_VALUES = {
  message: '',
}
